import type { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { duotoneIcons } from "./duotone";
import { kitIcons } from "./kit";
import { lightIcons } from "./light";
import { regularIcons } from "./regular";
import { solidIcons } from "./solid";

export const icons: IconDefinition[] = [
    ...duotoneIcons,
    ...lightIcons,
    ...solidIcons,
    ...regularIcons,
    ...kitIcons,
];
